/**
 * ConnectionStatus - WebSocket Connection Indicator
 * Indicatore real-time della connessione WebSocket
 */

import React from 'react'
import { Badge } from '@/shared/components/ui/badge'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/shared/components/ui/tooltip'
import { Wifi, WifiOff, Loader2 } from 'lucide-react'

interface ConnectionStatusProps {
  status: 'connected' | 'connecting' | 'disconnected'
}

export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({ status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'connected':
        return {
          icon: <Wifi className="h-3 w-3" />,
          text: 'Connesso',
          variant: 'default' as const,
          className: 'bg-green-100 text-green-800 border-green-200',
          tooltip: 'Connessione realtime attiva'
        }
      case 'connecting':
        return {
          icon: <Loader2 className="h-3 w-3 animate-spin" />,
          text: 'Connessione...',
          variant: 'secondary' as const,
          className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
          tooltip: 'Connessione in corso...'
        }
      case 'disconnected':
        return {
          icon: <WifiOff className="h-3 w-3" />,
          text: 'Disconnesso',
          variant: 'destructive' as const,
          className: 'bg-red-100 text-red-800 border-red-200',
          tooltip: 'Connessione realtime persa'
        }
    }
  }

  const config = getStatusConfig()

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <Badge className={`text-xs px-2 py-1 ${config.className}`}>
            {config.icon}
            <span className="ml-1">{config.text}</span>
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <p>{config.tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
